import api from '../api/axios';

// Auto-supplies catalog (BOM rules): which accessories are ordered together
// with equipment when the order is generated automatically.
const getAll = () => {
  return api.get('/supply-rules');
};

const getById = (id) => {
  return api.get(`/supply-rules/${id}`);
};

const create = (rule) => {
  return api.post('/supply-rules', rule);
};

const update = (id, rule) => {
  return api.patch(`/supply-rules/${id}`, rule);
};

const remove = (id) => {
  return api.delete(`/supply-rules/${id}`);
};

const supplyRulesServices = {
  getAll,
  getById,
  create,
  update,
  remove,
};

export default supplyRulesServices;
